import React from 'react';
import Skeleton from "react-loading-skeleton";
import '../Css/homeSkeleton.css';

const HeroSkeleton = () => {
  return (
    <div className='homeSkeleton'>
      <div className='mainHomeSkeleton'>
        <div className='skeletonHero'>
          <Skeleton height="250px" width="100%" />
        </div>
      </div>
    </div>
  )
}

export default HeroSkeleton